<template>
  <div
    class="copy-wrapper"
    :is-button="isButton"
    @click="copyToClipboard"
  >
    <DsButton
      v-if="isButton"
      class="copy-wrapper__button"
      color="primary"
      size="dense"
      :disabled="disabled"
    >
      {{ buttonText }}
    </DsButton>
    <StIcon
      v-else
      v-tooltip.top-end="tooltip"
      icon-name="content-copy"
      class="copy-wrapper__icon"
    />
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import { DsButton } from '@ds/components';

export default {
  name: 'CopyToClipboard',
  components: {
    StIcon,
    DsButton,
  },
  props: {
    tooltip: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.label.tooltip.copy');
      },
    },
    content: {
      type: String,
      default: '',
    },
    messageSuccess: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.notification.success.copy');
      },
    },
    messageError: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.notification.error.copy');
      },
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.label.button');
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.content).then(() => {
        this.$noty.success(this.messageSuccess);
      }, (err) => {
        console.error(this.messageError, err);
        this.$noty.error(this.messageError);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .copy-wrapper {
    display: contents;

    &__icon {
      margin-left: 15px;
      cursor: pointer;
    }

    &__button {
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
      margin: var(--ds-spacing-inline-nano) var(--ds-spacing-stack-quark) var(--ds-spacing-inline-md) 0;
    }
  }
</style>
